import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import CourseCombo from '../combos/CourseCombo';
import TeacherCombo from '../combos/TeacherCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Container, Form, Row } from 'react-bootstrap';
import StudentCombo from '../combos/StudentCombo';
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';


export default function StudentDisorders(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [comboVisible, setComboVisible] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [btnVisible, setBtnVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [student, setStudent] = useState(null);
  const [schoolClass, setSchoolClass] = useState(null);

  const [disorders, setDisorders] = useState([]);

  useEffect(() => {
    var user = util.getCurrentUser();
    if(user.Role === 5){
      setScoreVisible(true);
      setComboVisible(false);
      loadScores(user.UserId);
    }
    else if(user.Role === 6){
      setComboVisible(true);
    }
  }, []);

  const loadScores = function(stuId){
      setLoading(true);
      var params = {login:util.getTrustedUser(), schoolClassId:"", studentId:stuId, sheetType:3};
      var url = config.Server+`/school/month/grade-sheet/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  response = response[0];
                  console.log("resopnse is> ", response);
                  var sc = response.schoolClass;
                  setSchoolClass(sc);
                  setDisorders(response);
                  setScoreVisible(true);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
            console.log("error is>", error)
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
  }
  const onStudentSelected = function(value){
    setScoreVisible(false);
    setLoading(false);
    setStudent(value);
    var hasStu = false;
    if(value)if(value.id) hasStu = true;
    setBtnVisible(hasStu);
    setScoreVisible(hasStu);

  }
  return (
    <>
    {
      comboVisible?
      <Row>
        <Col md={3}>
          <StudentCombo value={student} onChange={(value)=>{ onStudentSelected(value.itemValue)}}  returnFullItem={true}/>
        </Col>
        <Col md={3} style={{paddingTop:"30px"}}>
          <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
            {btnVisible?<Button label="مشاهده بی نظمی ها" icon="pi pi-check" onClick={()=>{loadScores(student.id)}} severity="success" iconPos="right" loading={loading} />: <></>}
          </div>          
        </Col>
      </Row>
      :<></>
    }
      {
        scoreVisible?
        <div>
          {
            loading?
            <>loading...</>
            :
            <>
            <Container fluid>
              {
                schoolClass && schoolClass.id?
                <Row>
                  <Col>
                    کلاس: {schoolClass.name + ", " + schoolClass.field.title + ", پایه:" + util.getDegreeChar(schoolClass.degree)}
                  </Col>
                </Row>
                :<></>
              }
              <Row style={{overflow:"scroll", marginTop:"10px", marginBottom:"50px"}}>
                <Col md={12} style={{textAlign:"right"}}>
                  لیست بی نظمی ها {}
                </Col>
                <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
                  <thead>
                    <tr style={{backgroundColor:"#555", color:"#FFF"}}>
                      <td style={{textAlign:"center", width:"70px", padding:"5PX", border:"1px solid #b0b0b0"}}>#</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>تاریخ</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>نوع آیتم</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>شرح</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>نمره مثبت</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>نمره منفی</td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      disorders.items == null?
                      <></>
                      :
                      <>
                        {disorders.items.map((score, scoreInd) => 
                          <tr>
                            <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>{scoreInd+1}</td>
                            <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{util.SeperateDate(score.issueDate)}</td>
                            <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.disorderTypeTitle}</td>
                            <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0"}}>{score.comment}</td>
                            <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", color:"rgba(20, 151, 20, 1)"}}>{score.positiveScore>0?score.positiveScore:""}</td>
                            <td style={{padding:'3px', textAlign:'center', border:"1px solid #b0b0b0", color:"#F00"}}>{score.negativeScore>0?score.negativeScore:""}</td>
                          </tr>
                        )}
                      </>
                    }
                    <tr style={{backgroundColor:"#e0e0e0"}}>
                      <td colSpan={4} style={{textAlign:"left", padding:"5PX", border:"1px solid #b0b0b0"}}>جمع نمرات</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0", color:"rgba(20, 151, 20, 1)"}}>{disorders.positiveSum}</td>
                      <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0", color:"#F00"}}>{disorders.negativeSum}</td>
                    </tr>
                  </tbody>
                </table>
              </Row>
            </Container>
            </>
          }
        </div>
        :
        <></>
      }
    </>
  );
}
